























































































import { Component, Prop, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { Route } from "vue-router";
// service methods
import { getPlayerMonitor, createPlayerMonitor, updatePlayerMonitor } from "@/services/players/playerMonitorService";
import { validateForm } from "@/services/validation/validationService";
import validate from "@/directives/validate";
import { getSetting, setSetting } from "@/services/autoSettings/autoSettingsService";
// components
import vSelect from "vue-select";
import PlayerMonitorSettings from "@/components/players/PlayerMonitorSettings.vue";
import PlayerMonitorSubscribers from "@/components/players/PlayerMonitorSubscribers.vue";
import PlayerMonitorPlayers from "@/components/players/PlayerMonitorPlayers.vue";
import UnsavedFormModal from "@/components/common/modals/UnsavedFormModal.vue";
import HeaderActionButtons from "@/components/layouts/HeaderActionButtons.vue";
// types
import { MonitorPlayer, MonitorSubscriber, PlayerMonitor, PMSettings } from "@/services/players/types";
import { settingsValidators } from "@/components/players/playerMonitorValidators";
import { FormComponent, FormComponentModel } from "@/services/autoSettings/types";
import i18n from "@/i18n";
import { bus } from "@/bus";

@Component<PlayerMonitorForm>({
    beforeRouteLeave(to, from, next) {
        this.onBeforeRouteLeave(to, next);
    },
    directives: {
        validate
    },
    components: {
        vSelect,
        PlayerMonitorSettings,
        PlayerMonitorSubscribers,
        HeaderActionButtons,
        UnsavedFormModal,
        PlayerMonitorPlayers
    }
})
export default class PlayerMonitorForm extends Vue {
    @Prop() private playerMonitorId!: string;
    @Getter("getCurrentUser", { namespace: "authentication" }) getCurrentUser: any;

    validators = settingsValidators;
    componentsData = [] as FormComponentModel[];
    formState = false;
    routeParams = {};
    localId = this.playerMonitorId || "";
    nextRoute = "";
    saveClicked = false;
    continue = false;

    playerMonitor = {
        id: "",
        name: "",
        description: "",
        playerId: false,
        timestamp: false,
        pcName: false,
        ipAddress: false,
        solutionName: false,
        playerFolderPath: false,
        monitorAllPlayers: true,
        notificationIntervalHours: 1,
        subscribers: [],
        players: []
    } as PlayerMonitor;

    // used for comparing if form have changes
    priorPlayerMonitorState = JSON.parse(JSON.stringify(this.playerMonitor)) as PlayerMonitor;

    // lifecycle hooks
    public created() {
        this.fetchData().then(() => {
            this.initComponents();
        });
    }

    onBeforeRouteLeave(to: Route, next: any) {
        if (this.saveClicked || this.continue) {
            next();
        } else {
            this.nextRoute = to.name ? to.name : "";
            this.routeParams = to.params;
            this.retrieveData();
            const noChanges = this.lodash.isEqual(this.priorPlayerMonitorState, this.playerMonitor);
            if (noChanges) {
                next();
            } else {
                next(false);
                (this.$refs.UnsavedFormModal as any).open();
            }
        }
    }

    // computed
    get settings(): PMSettings {
        return this.playerMonitor ? {
            description: this.playerMonitor.description,
            playerId: this.playerMonitor.playerId,
            timestamp: this.playerMonitor.timestamp,
            pcName: this.playerMonitor.pcName,
            ipAddress: this.playerMonitor.ipAddress,
            solutionName: this.playerMonitor.solutionName,
            playerFolderPath: this.playerMonitor.playerFolderPath,
            monitorAllPlayers: this.playerMonitor.monitorAllPlayers,
            notificationIntervalHours: this.playerMonitor.notificationIntervalHours
        } : {} as PMSettings;
    }

    get subscribers(): Array<MonitorSubscriber> {
        return this.playerMonitor.subscribers;
    }

    get players(): Array<MonitorPlayer> {
        return this.playerMonitor.players;
    }

    // methods
    async fetchData() {
        if (!this.localId) return;

        getPlayerMonitor(this.localId).then(response => {
            this.playerMonitor = response;
            bus.$emit("documentTitle", this.playerMonitor.name);
            this.priorPlayerMonitorState = JSON.parse(JSON.stringify(this.playerMonitor));
        });
    }

    onSettingsUpdated(settings: PMSettings) {
        this.playerMonitor.description = settings.description;
        this.playerMonitor.playerId = settings.playerId;
        this.playerMonitor.timestamp = settings.timestamp;
        this.playerMonitor.pcName = settings.pcName;
        this.playerMonitor.ipAddress = settings.ipAddress;
        this.playerMonitor.solutionName = settings.solutionName;
        this.playerMonitor.playerFolderPath = settings.playerFolderPath;
        this.playerMonitor.monitorAllPlayers = settings.monitorAllPlayers;
        this.playerMonitor.notificationIntervalHours = settings.notificationIntervalHours;
    }

    onSubscribersUpdated(data: Array<MonitorSubscriber>) {
        this.playerMonitor.subscribers = data;
    }

    onPlayersUpdated(data: Array<MonitorPlayer>) {
        this.playerMonitor.players = data;
    }

    changeItemName = false;
    get showNameInput() : boolean {
        if ((typeof this.validators.name.state !== "undefined" || this.validators.name.state !== null) &&
            this.validators.name.state === false) {
            this.changeItemName = true;
        }

        return this.changeItemName;
    }

    toggleName(event: any) {
        // if input is invalid do nothing
        if (typeof this.validators.name.state !== "undefined" &&
            this.validators.name.state === false) {
            return;
        }

        this.changeItemName = false;
    }

    onContinue(data: boolean) {
        this.continue = data;
        if (data) this.$router.push({ name: this.nextRoute, params: this.routeParams });
        this.nextRoute = "";
    }

    async save(back: boolean) {
        this.saveClicked = true;
        await this.childComponentsHandler();
        if (!this.formState) {
            this.saveClicked = false;
            return;
        }

        if (!this.localId) {
            createPlayerMonitor(this.playerMonitor).then((id: string) => {
                if (back) this.$router.push({ path: `/playerMonitors` });
                else {
                    this.localId = id;
                    this.playerMonitor.id = id;
                    this.priorPlayerMonitorState = JSON.parse(JSON.stringify(this.playerMonitor)) as PlayerMonitor;
                    this.saveClicked = false;
                }
            });
            return;
        }

        updatePlayerMonitor(this.playerMonitor).then(() => {
            if (back) this.$router.push({ path: `/playerMonitors` });
            this.priorPlayerMonitorState = JSON.parse(JSON.stringify(this.playerMonitor)) as PlayerMonitor;
            this.saveClicked = false;
        });
    }

    back() {
        window.history.go(-1);
    }

    // components structure
    async initComponents() {
        let autoSettingComponents = getSetting(this.componentsAutoSettingKey) as FormComponent[];
        const defaultComponents = [
            {
                componentName: "PlayerMonitorSettings",
                sectionName: i18n.t("playerMonitors.details"),
                order: 0,
                collapseState: true
            },
            {
                componentName: "PlayerMonitorPlayers",
                sectionName: i18n.t("playerMonitors.players"),
                order: 1,
                collapseState: true
            },
            {
                componentName: "PlayerMonitorSubscribers",
                sectionName: i18n.t("playerMonitors.subscribers"),
                order: 2,
                collapseState: true
            }] as FormComponent[];

        if (!autoSettingComponents) {
            autoSettingComponents = await this.initAutoSettings(defaultComponents);
        } else {
            // Check if saved auto setting components has same component and if not then set to default components.
            var hasSameComponents = this.lodash.isEqual(
                this.lodash.sortBy(autoSettingComponents.map(component => component.componentName)),
                this.lodash.sortBy(defaultComponents.map(component => component.componentName))
            );
            if (hasSameComponents) {
                await this.updateComponents(defaultComponents, autoSettingComponents);
            } else {
                autoSettingComponents = await this.initAutoSettings(defaultComponents);
            }
        }

        this.componentsData = autoSettingComponents.map((x: FormComponent) => ({
            componentName: x.componentName,
            order: x.order,
            active: false,
            activeDropTarget: false,
            collapseState: x.collapseState,
            sectionName: x.sectionName
        }));
    }

    async initAutoSettings(defaultComponents: FormComponent[]) {
        await setSetting(this.componentsAutoSettingKey,
            defaultComponents);
        return getSetting(this.componentsAutoSettingKey);
    }

    async updateComponents(defaultComponents: FormComponent[], components: FormComponent[]) {
        let updateSettings = false;

        const componentsToBeAdded = defaultComponents
            .filter(x => !components.map(x => x.componentName).includes(x.componentName));
        const componentsToBeRemoved = components
            .filter(x => !defaultComponents
                .map(x => x.componentName).includes(x.componentName));
        if (componentsToBeAdded.length > 0) {
            components = components.concat(componentsToBeAdded);
        }
        if (componentsToBeRemoved.length > 0) {
            componentsToBeRemoved.forEach(cr => {
                components = components.filter(x => x.componentName === cr.componentName);
            });
        }

        if (componentsToBeAdded.length > 0 || componentsToBeRemoved.length > 0) {
            components.sort((a, b) => a.order - b.order)
                .forEach((el, index) => {
                    el.order = index;
                });
            updateSettings = true;
        }

        components.forEach(c => {
            const dc = defaultComponents.find(x => x.componentName === c.componentName);
            if (dc && dc.sectionName !== c.sectionName) {
                c.sectionName = dc.sectionName;
                updateSettings = true;
            }
        });

        if (updateSettings) {
            await setSetting(this.componentsAutoSettingKey,
                components);
        }

        return components;
    }

    async childComponentsHandler() {
        const components = this.$refs.childComponent as any[];
        const validators = [] as any[];
        components.forEach(component => {
            if (component.validators) { validators.push(component.validators); }
            if (typeof component.emitData === "function") { component.emitData(); }
        });

        this.formState = await validateForm(validators);
    }

    retrieveData() {
        const components = this.$refs.childComponent as any[];
        components.forEach(component => {
            if (typeof component.emitData === "function") { component.emitData(); }
        });
    }

    onComponentStateChanged(componentState: any) {
        const component = this.componentsData.find(x => x.componentName === componentState.name);
        if (!component) return;

        component.collapseState = componentState.state;
        setSetting(this.componentsAutoSettingKey,
            this.componentsData.map(x => (
                {
                    componentName: x.componentName,
                    order: x.order,
                    collapseState: x.collapseState,
                    sectionName: x.sectionName
                } as FormComponent)));
    }

    get components(): FormComponentModel[] {
        let components = this.componentsData.sort((x, y) => x.order - y.order);
        if (this.playerMonitor.monitorAllPlayers) {
            components = components.filter(x => x.componentName !== "PlayerMonitorPlayers");
        }
        return components;
    }

    get componentsAutoSettingKey(): string {
        let settingsKey = "playerMonitorFormComponents";
        settingsKey += this.localId ? "-edit" : "-create";
        return settingsKey;
    }

    // drag & drop event handlers
    drag(event: any) {
        event.dataTransfer.setData(
            "id",
            event.target.id
        );
        const component = this.componentsData.find(x => x.componentName === event.target.id);
        if (component) {
            component.active = true;
        }
    }

    dragLeave(event: any) {
        const component = this.componentsData.find(x => x.componentName === event.currentTarget.id);
        if (!component) return;
        component.activeDropTarget = false;
    }

    dragOver(event: any) {
        event.preventDefault();
        const component = this.componentsData.find(x => x.componentName === event.currentTarget.id);
        if (!component) return;
        if (component.active) return;
        component.activeDropTarget = true;
    }

    dragEnd() {
        this.componentsData.forEach(x => {
            x.activeDropTarget = false;
            x.active = false;
        });
    }

    swapComponents(event: any) {
        event.preventDefault();
        if (!event.currentTarget) {
            return;
        }

        const target = this
            .componentsData
            .find(x => event.currentTarget && x.componentName === event.currentTarget.id);
        const source = this
            .componentsData
            .find(x => event.dataTransfer && x.componentName === event.dataTransfer.getData("id"));

        if (!(source && target)) { return; }

        const sourceOrder = source.order;
        source.order = target.order;
        target.order = sourceOrder;

        setSetting(this.componentsAutoSettingKey,
            this.componentsData.map(x => (
                {
                    componentName: x.componentName,
                    order: x.order,
                    collapseState: x.collapseState,
                    sectionName: x.sectionName
                } as FormComponent)));
    }
}
